import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);
// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/);

const modules = requireContext.keys()
    .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
    .reduce((modules, [name, module]) => {
        if (module.namespaced === undefined) {
            module.namespaced = true
        }

        return {
            ...modules,
            [name]: module
        }
    }, {});

export default new Vuex.Store({
    modules,
    plugins: [
        createPersistedState({
            paths: [
                'auth',
                'customer.selected_customer_name',
                'location',
                'order.order_items',
                'order.order_type',
                'order.sale',
                'order.order',
                'order.tmp_promo_code',
                'order_list.filter_print_list',
                'order.order_modify',
                'lang', 'currency',
                'pre_printing',
                'restaurant.restaurant',
                'printer',
                'restaurant.shortcut'
            ],
        })
    ]
})
